/**
 * [sc-48351] Il conteggio accanto alle pagine: «11-20 di 45».
 *
 * L'API manda `startItem = 1` anche quando non c'è niente, e la pagina
 * mostrava «1-0 di 0». Senza risultati si dice «0 di 0».
 *
 * @param {{startItem?: number, endItem?: number, totalItems?: number}} [p]
 */
export function testoConteggio(p) {
  const totale = Number(p?.totalItems) || 0;
  if (totale === 0) return "0 di 0";
  return `${p.startItem}-${p.endItem} di ${totale}`;
}
